module.exports = __webpack_public_path__ + "media/images/top/top/bg_hero_pc-8ad97645f6c1a5c8ee06efe71e898a90.png";